import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  primaryColor: '#285FF6',
  secondaryColor: '#374151',
  warning: '#ffcc00',
  error: '#E80A0A',
  success: '#96F50F',
  statusPending: '#E6DFBF'
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {}
});

export default themeSlice.reducer;
